
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findCustomerClubDB"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCustomerClubDB"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"birthday"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sex"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"zusatz"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"custno"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isForPCA"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isWeekday"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"memberstatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numvouchersoverall"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numvouchersfree"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numvoucherssold"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numvouchersused"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"picture"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"creditAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"creditPaymentID"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"partnerClubs"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pcaid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numVouchers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customerNumVouchers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numvouchersmax"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"articlePrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"articleID"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"articlename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priceToPay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"itemsPayed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"playingConditions"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":480}};
    doc.loc.source = {"body":"query findCustomerClubDB {\n    findCustomerClubDB {\n      customer {\n        firstname, lastname, birthday, sex, title, zusatz, email, custno, id, isForPCA, isWeekday, memberstatus, numvouchersoverall, numvouchersfree, numvoucherssold, numvouchersused, picture, creditAmount, creditPaymentID,\n        partnerClubs { pcaid, id, name, numVouchers, customerNumVouchers, numvouchersmax, articlePrice, articleID, articlename, priceToPay, itemsPayed, playingConditions }\n      }\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["findCustomerClubDB"] = oneQuery(doc, "findCustomerClubDB");
        
